import { Token } from "../stores/slices/authSlice";

export const encodeTokenToHash = (token: Token): string => {
  const createdTimestamp = Math.floor(
    new Date(token.tokenCreatedTimestamp).getTime() / 1000
  );
  const expirationTimestamp = Math.floor(
    new Date(token.tokenExpirationTimestamp).getTime() / 1000
  );
  return `#/en/sso/${
    token.tokenId
  }_${createdTimestamp}_${expirationTimestamp}_${
    token.sessionReferenceNumber
  }__${token.applicationVersionNumber}_${
    token.resetSecurityCheckpoint ? "1" : "0"
  }_${token.firstName}_${token.lastName}_${
    token.tokenIsAuthenticated ? "1" : "0"
  }_${token.userRoleId}_${token.userRoleName}`;
};
